import { Button, Col, Form, Input, Modal, Row, Table } from "antd";
import Loading from "../../auxiliary/loader/loading";
import { NotFound } from "../../../sources/svg/svg";
import { useEffect, useState } from "react";
import { useLayout } from "../../layouts/layout";
import { useCrm } from "../../../tools/api";
import BarCodePost from "../../auxiliary/barcode/barcode";
import { successMessage } from "../../../tools/toastifyShowMessage";
import { InfoCircleOutlined } from "@ant-design/icons";

const PrintBarCode = () => {
  const { setLayout } = useLayout();

  const { querySPPurchasePrintBarcodeState, updateSPPurchaseFromPrintBarcodeToFinalState } = useCrm();

  const [isLoading, setIsLoading] = useState(false);

  const [purchaseList, setPurchaseList] = useState([]);
  const [resultSearch, setResultSearch] = useState([]);

  const [isOpenModal, setIsOpenModal] = useState(false);

  useEffect(() => {
    CartableListServ();
  }, []);
  const CartableListServ = async () => {
    setIsLoading(true);
    let response = await querySPPurchasePrintBarcodeState();
    if (response) {
      setPurchaseList(response?.Result);
      setResultSearch(response?.Result);
    }
    setIsLoading(false);
  };

  const handleSearch = (e) => {
    let search = e.target.value;
    let result = purchaseList.filter((item) => {
      return Object.keys(item).some((k) => {
        return String(item[k]).toLowerCase().includes(search.toLowerCase());
      });
    });
    setResultSearch(result);
  };

  const retPrintHandler = (item) => {
    return {
      kit: item.iccid.slice(9, 19),
      barcode: item.barcode,
      province: item.provinceName,
      city: item.cityName,
      fname: item.firstName,
      lname: item.lastName,
      certNo: item.certNO,
      postalcode: item.postalCode,
      msisdn: item.smsMobileNo,
      mainstreet: item.mainStreet,
      auxiliaryroad: item.auxiliaryRoad,
      alley: item.alley,
      block: item.block,
      buildingNo: item.buildingNo,
      unit: item.unit,
      floor: item.floor,
    };
  };

  const printHandler = (state = false) => {
    setIsLoading(true);
    if (purchaseList.length > 0) {
      Promise.all(
        purchaseList.map((item) => {
          return retPrintHandler(item);
        }),
      ).then((prints) => {
        let print = prints.map((print, index) => <BarCodePost key={index} print={print} isBig={state} />);
        setLayout(print);
        setTimeout(() => {
          setIsLoading(false);
          window.print();
        }, 1000);
      });
    }
  };

  const transmitToBarCode = async () => {
    setIsLoading(true);
    const response = await updateSPPurchaseFromPrintBarcodeToFinalState();
    if (!response?.HasError) {
      successMessage("هملیات با موفقیت پایان یافت");
    }
    setIsLoading(false);
  };

  return (
    <>
      <div className="g-body-format-page">
        <div className="holder-form-filter">
          <Form layout="vertical">
            <Row gutter={16}>
              <Col span={6}>
                <Form.Item className="input-normal" label="جستجو">
                  <Input placeholder="جستجو" dir="ltr" allowClear onChange={handleSearch} />
                </Form.Item>
              </Col>
            </Row>
          </Form>
        </div>
        <div className="holder-table">
          <Table
            // rowSelection={rowSelection}
            className="tbl-normal"
            columns={[
              {
                title: "شماره آپتل",
                dataIndex: "msisdn",
                key: "msisdn",
                width: 150,
              },
              {
                title: "شماره کیت",
                dataIndex: "iccid",
                key: "iccid",
                width: 150,
              },
              {
                title: "کدملی",
                dataIndex: "certno",
                key: "certno",
                width: 150,
              },
              {
                title: "نام",
                dataIndex: "fname",
                key: "fname",
                width: 150,
              },
              {
                title: "نام خانوادگی",
                dataIndex: "lname",
                key: "lname",
                width: 150,
              },
              {
                title: "چاپ تکی بارکد",
                dataIndex: "print",
                key: "print",
                width: 150,
              },
            ]}
            locale={{
              emptyText: (
                <>
                  <NotFound text={"رکوردی یافت نشد."} />
                </>
              ),
            }}
            pagination={{
              className: "page-pagination",
              // position: [totalRecord.length > 10 ? "bottomLeft" : "none"],
              align: "start",
            }}
            dataSource={resultSearch.map((item, key) => ({
              key: key,
              msisdn: item.msisdn,
              iccid: item?.iccid?.slice(9, 19),
              certno: item.certNO,
              fname: item.firstName,
              lname: item.lastName,
              fathername: item.fatherName,
              print: (
                <>
                  <div className="holder-button-on-table">
                    <Button
                      className="btn-normal"
                      onClick={() => {
                        const retData = retPrintHandler(item);
                        setLayout(<BarCodePost print={retData} isBig={true} lang="fa" />);
                        setTimeout(() => {
                          window.print();
                        }, 1000);
                      }}
                    >
                      چاپ بارکد بزرگ
                    </Button>
                    <Button
                      className="btn-normal"
                      onClick={() => {
                        const retData = retPrintHandler(item);
                        setLayout(<BarCodePost print={retData} isBig={false} lang="fa" />);
                        setTimeout(() => {
                          window.print();
                        }, 1000);
                      }}
                    >
                      چاپ بارکد کوچک
                    </Button>
                  </div>
                </>
              ),
            }))}
          ></Table>
        </div>
        <div className="holder-export-group-print">
          <Button
            onClick={() => {
              printHandler(false);
            }}
            className="btn-normal btn-print"
            type="default"
            icon={<i className="icon-print"></i>}
          >
            چاپ پاکت کوچک
          </Button>
          <Button
            onClick={() => {
              printHandler(true);
            }}
            className="btn-normal btn-print"
            type="default"
            icon={<i className="icon-print"></i>}
          >
            چاپ پاکت بزرگ
          </Button>
        </div>
      </div>
      <div className="g-footer-format-page">
        <div className="holder-button">
          <Button
            onClick={() => {
              resultSearch.length > 0 && setIsOpenModal(true);
            }}
            htmlType="submit"
            className="btn-normal btn-aptel"
            type="primary"
            danger
          >
            پایان عملیات
          </Button>
        </div>
      </div>
      <Modal centered className="modal-confirm-global" footer={[]} open={isOpenModal} onCancel={() => setIsOpenModal(false)}>
        <div className="modal-confirm">
          <div className="modal-body">
            <div className="confirm-body">
              <div className="holder-icon">
                <InfoCircleOutlined />
              </div>
              <p>آیا از انجام اعملیات مطمین هستید؟</p>
            </div>
          </div>
          <div className="modal-footer">
            <div className="holder-button">
              <Button className="btn-normal btn-green" onClick={transmitToBarCode}>
                تایید
              </Button>
              <Button className="btn-normal" onClick={() => setIsOpenModal(false)}>
                انصراف
              </Button>
            </div>
          </div>
        </div>
      </Modal>
      <Loading isOpen={isLoading} />
    </>
  );
};

export default PrintBarCode;
